import React, { Component } from "react";
import Axios from "axios";
import { getUser } from "../../actions/session";
import {
  CARRIER_TABLE_STATS,
  LOGIN_URL,
  ALL_CARRIER_LIST,
  SERVER_PATH,
} from "../../config/rest_endpoints";
import CustomLoader from "../common/loader";
import ReactTooltip from "react-tooltip";
import { Notifications } from "../common/notification";
import { Redirect, withRouter } from "react-router";
import MultiSelect from "@khanacademy/react-multi-select";
import { Link } from "react-router-dom";
import { CARRIER_PER_DAY } from "../routers/RouteConstants";
import { fmtDollar4, fmtMins, fmtInt } from '../common/formatters';

// datetime picker imports
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";

class ChangeCarrierStats extends Component {
  constructor(props) {
    super(props);
    // initializing states
    this.state = {
      User: getUser(),
      data: [],
      startDate: moment(new Date()),
      endDate: moment(new Date()),
      quickDatePreset: "today",
      isGetting: false,
      isGettingReport: false,
      isLoginURL: false,
      carrierList: [],
      selectedCarrier: [],
      isBtnSpin: false,
      isDownLoadSpin: false,
      expandedRows: {},
      carrierReport: [],
      sortColumn: null,
      sortDirection: "asc",
      excludeNoActivity: true,
    };
    this.getReportOnSelectDate = this.getReportOnSelectDate.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.handleQuickDateSelect = this.handleQuickDateSelect.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleExcludeNoActivity = this.handleExcludeNoActivity.bind(this);
  }

  componentDidMount() {
    this.getReportOnSelectDate();
    this.getAllCarrierNames();
    this.setState({ isBtnSpin: false, isDownLoadSpin: false });
  }

  // handle date and time on selection of datetime picker
  handleDate(date, value) {
    if (value == "start") {
      this.setState({ startDate: date, quickDatePreset: "" }, () => {
        console.log("start", this.state.startDate);
      });
    } else {
      this.setState({ endDate: date, quickDatePreset: "" }, () => {
        console.log("end", this.state.endDate);
      });
    }
  }

  handleQuickDateSelect(preset) {
    let startDate, endDate;
    switch (preset) {
      case "today":
        startDate = moment().utc().startOf("day");
        endDate = moment().utc();
        break;
      case "yesterday":
        startDate = moment().utc().subtract(1, "day").startOf("day");
        endDate = moment().utc().subtract(1, "day").endOf("day");
        break;
      case "thisWeek":
        startDate = moment().utc().startOf("isoWeek");
        endDate = moment().utc();
        break;
      case "thisMonth":
        startDate = moment().utc().startOf("month");
        endDate = moment().utc();
        break;
      default:
        return;
    }
    this.setState({ startDate, endDate, quickDatePreset: preset });
  }

  toggleRow(rowId) {
    const { User, startDate, endDate, expandedRows } = this.state;
    let StDate = moment(startDate).format("MM/DD/YYYY, h:mm:ss A");
    let enDate = moment(endDate).format("MM/DD/YYYY, h:mm:ss A");
    const isExpanded = expandedRows[rowId];

    const selectedRow = this.state.data[rowId];

    const newExpandedRows = {};
    for (let key in expandedRows) {
      newExpandedRows[key] = false;
    }

    console.log("selectedRow", selectedRow);
    if (!isExpanded) {
      // If the row is not expanded
      const carrierID = selectedRow.carrierID;
      const url = `${SERVER_PATH}/apiv1/reporting/account/stats/carrier/${carrierID}`;
      const payload = {
        startDate: StDate,
        endDate: enDate,
        carrierID: carrierID,
      };
      this.setState({ isGettingReport: true });
      const headers = { Authorization: "Bearer " + User.token };
      Axios.post(url, payload, { headers })
        .then((res) => {
          console.log("POST request successful:", res.data);
          if (res) {
            var resp = res.data.data || [];
            this.setState({
              carrierReport: resp,
              expandedRows: {
                ...newExpandedRows,
                [rowId]: true,
              },
              isGettingReport: false,
            });
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
      this.setState({
        expandedRows: {
          ...newExpandedRows,
          [rowId]: true,
        },
        isGettingReport: true,
      });
    } else {
      // If the row is expanded, simply collapse it
      this.setState({
        expandedRows: newExpandedRows,
        isGettingReport: false,
      });
    }
  }

  getAllCarrierNames() {
    const { User } = this.state;

    var headers = { Authorization: "Bearer " + User.token };
    Axios.get(ALL_CARRIER_LIST, { headers })
      .then((res) => {
        if (res) {
          var resp = res.data.data;
          const list = resp.map((row) => {
            row["label"] = row["name"];
            row["value"] = row["domain"];
            return row;
          });
          this.setState({ carrierList: list });
        }
      })
      .catch((err) => {
        const alert = err.response;
        console.log(`alert.data.message`, alert.data.message);
        if (alert.data.message === "invalid or expired jwt") {
          localStorage.removeItem("user");
          this.setState({ isLoginURL: true });
          Notifications.notify(alert.data.message, "Token Expire", "error");
        }
        Notifications.notify(alert.data.message, "Failed", "error");
        this.setState({
          isGetting: false,
        });
      });
  }

  handleExcludeNoActivity(e) {
    this.setState({ excludeNoActivity: e.target.checked });
  }

  // on filter we are Carrier stats
  getReportOnSelectDate(data) {
    const { User, startDate, endDate, selectedCarrier, excludeNoActivity } =
      this.state;
    console.log("startDate", startDate);
    var payload = {
      startDate: moment(startDate).format("MM/DD/YYYY, h:mm:ss A"),
      endDate: moment(endDate).format("MM/DD/YYYY, h:mm:ss A"),
      accounts: selectedCarrier,
      excludeOnesWithNoActivity: excludeNoActivity,
    };
    console.log(`payload`, payload);
    this.setState({ isGetting: true, isBtnSpin: true, isDownLoadSpin: false });
    var headers = { Authorization: "Bearer " + User.token };
    if (data === "download") {
      this.setState({
        isGetting: false,
        isBtnSpin: false,
        isDownLoadSpin: true,
      });
      Axios.post(`${CARRIER_TABLE_STATS}?download=true`, payload, { headers })
        .then((res) => {
          if (res) {
            var resp = res.data;
            const getFileName = res.headers["content-disposition"];
            const settingFileName = getFileName.replace(
              "attachment; filename=",
              ""
            );
            const url = window.URL.createObjectURL(new Blob([resp]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${settingFileName}.csv`);
            document.body.appendChild(link);
            Notifications.notify(
              "File is been downloading...",
              "Downloading",
              "success"
            );
            link.click();
            this.setState({
              isGetting: false,
              isBtnSpin: false,
              isDownLoadSpin: false,
            });
          }
        })
        .catch((err) => {
          const alert = err.response;
          console.log(`alert.data.message`, alert.data.message);
          if (alert.data.message === "invalid or expired jwt") {
            localStorage.removeItem("user");
            this.setState({ isLoginURL: true });
            Notifications.notify(alert.data.message, "Token Expire", "error");
          }
          Notifications.notify(alert.data.message, "Failed", "error");
          this.setState({
            isGetting: false,
            isBtnSpin: false,
          });
        });
    } else {
      Axios.post(CARRIER_TABLE_STATS, payload, { headers })
        .then((res) => {
          if (res) {
            var resp = res.data.data;
            this.setState({
              data: resp,
              isGetting: false,
              isBtnSpin: false,
            });
          }
        })
        .catch((err) => {
          const alert = err.response;
          console.log(`alert.data.message`, alert.data.message);
          if (alert.data.message === "invalid or expired jwt") {
            localStorage.removeItem("user");
            this.setState({ isLoginURL: true });
            Notifications.notify(alert.data.message, "Token Expire", "error");
          }
          Notifications.notify(alert.data.message, "Failed", "error");
          this.setState({
            isGetting: false,
            isBtnSpin: false,
          });
        });
    }
  }

  returnTotal() {
    const { data } = this.state;
    let totalRevenue = [];
    let totalCost = [];
    let totalProfit = [];
    let totalMinutes = [];
    let totalACD = [];
    let totalSDP = [];
    let totalASR = [];
    let totalCompleted = [];
    let totalOutCalls = [];
    let totalSDCount = [];
    let totalAttempts404 = [];
    let totalAttempts487 = [];
    let totalAttempts4xx = [];
    let totalAttempts503 = [];
    let totalAttempts5xx = [];
    let totalAttempts6xx = [];

    if (data.length > 1) {
      data.forEach((item) => {
        totalRevenue.push(parseFloat(item["revenue"]) || 0);
        totalCost.push(parseFloat(item["cost"]) || 0);
        totalProfit.push(parseFloat(item["profit"]) || 0);
        totalMinutes.push(parseFloat(item["minutes"]) || 0);
        totalACD.push(item["ACD"]);
        totalSDP.push(item["SDP"]);
        totalASR.push(item["ASR"]);
        totalCompleted.push(parseFloat(item["completed"]) || 0);
        totalOutCalls.push(parseFloat(item["outCalls"]) || 0);
        totalSDCount.push(parseFloat(item["sdCount"]) || 0);
        totalAttempts404.push(
          item["attempts_404"] === "N/A"
            ? 0
            : parseFloat(item["attempts_404"]) || 0
        );
        totalAttempts487.push(
          item["attempts_487"] === "N/A"
            ? 0
            : parseFloat(item["attempts_487"]) || 0
        );
        totalAttempts4xx.push(
          item["attempts_4xx"] === "N/A"
            ? 0
            : parseFloat(item["attempts_4xx"]) || 0
        );
        totalAttempts503.push(
          item["attempts_503"] === "N/A"
            ? 0
            : parseFloat(item["attempts_503"]) || 0
        );
        totalAttempts5xx.push(
          item["attempts_5xx"] === "N/A"
            ? 0
            : parseFloat(item["attempts_5xx"]) || 0
        );
        totalAttempts6xx.push(
          item["attempts_6xx"] === "N/A"
            ? 0
            : parseFloat(item["attempts_6xx"]) || 0
        );
      });

      // Helper function to check if all values in an array are integers
      const isAllIntegers = (arr) => {
        return arr.every((val) => Number.isInteger(parseFloat(val)));
      };

      // Helper function to format total based on data type
      const formatTotal = (arr) => {
        const sum = arr.reduce((a, b) => a + b, 0);
        return isAllIntegers(arr) ? parseInt(sum) : sum.toFixed(2);
      };

      // Calculate sums for each metric
      const revenueSum = totalRevenue.reduce((a, b) => a + b, 0);
      const costSum = totalCost.reduce((a, b) => a + b, 0);
      const profitSum = totalProfit.reduce((a, b) => a + b, 0);
      const minutesSum = totalMinutes.reduce((a, b) => a + b, 0);
      const acdSum = totalACD.reduce((a, b) => a + b, 0);
      const sdpSum = totalSDP.reduce((a, b) => a + b, 0);
      const asrSum = totalASR.reduce((a, b) => a + b, 0);
      const completedSum = totalCompleted.reduce((a, b) => a + b, 0);
      const outCallsSum = totalOutCalls.reduce((a, b) => a + b, 0);
      const attempts404Sum = totalAttempts404.reduce((a, b) => a + b, 0);
      const attempts487Sum = totalAttempts487.reduce((a, b) => a + b, 0);
      const attempts4xxSum = totalAttempts4xx.reduce((a, b) => a + b, 0);
      const attempts503Sum = totalAttempts503.reduce((a, b) => a + b, 0);
      const attempts5xxSum = totalAttempts5xx.reduce((a, b) => a + b, 0);
      const attempts6xxSum = totalAttempts6xx.reduce((a, b) => a + b, 0);
      const sdCountSum = totalSDCount.reduce((a, b) => a + b, 0);

      // Log the total sums for each metric
      console.log("=== Total Sums ===");
      console.log("Total Revenue Sum:", revenueSum);
      console.log("Total Cost Sum:", costSum);
      console.log("Total Profit Sum:", profitSum);
      console.log("Total Minutes Sum:", minutesSum);
      console.log("Total ACD Sum:", acdSum);
      console.log("Total SDP Sum:", sdpSum);
      console.log("Total ASR Sum:", asrSum);
      console.log("Total Completed Sum:", completedSum);
      console.log("Total Out Calls Sum:", outCallsSum);
      console.log("Total Attempts 404 Sum:", attempts404Sum);
      console.log("Total Attempts 487 Sum:", attempts487Sum);
      console.log("Total Attempts 4xx Sum:", attempts4xxSum);
      console.log("Total Attempts 503 Sum:", attempts503Sum);
      console.log("Total Attempts 5xx Sum:", attempts5xxSum);
      console.log("Total Attempts 6xx Sum:", attempts6xxSum);
      console.log("Total SD Count Sum:", sdCountSum);

      return (
        <tr className="left_align" style={{ backgroundColor: "rgb(217 217 217 / 86%)", color: "black" }}>
          <td className="table-data"></td>
          <td className="table-data">
            <span style={{ fontWeight: "bold" }}>Total</span>
          </td>
          <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
            {fmtDollar4(totalRevenue.reduce((a, b) => a + b, 0))}
          </td>
          <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
            {fmtDollar4(totalCost.reduce((a, b) => a + b, 0))}
          </td>
          <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
            {fmtDollar4(totalProfit.reduce((a, b) => a + b, 0))}
          </td>
          <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
            {fmtMins(totalMinutes.reduce((a, b) => a + b, 0))}
          </td>
          <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
            {` ${this.calculateAverage(totalACD)}%`}
          </td>
          <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
            {` ${this.calculateAverage(totalSDP)}%`}
          </td>
          <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
            {` ${this.calculateAverage(totalASR)}%`}
          </td>
          <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
            {fmtInt(totalCompleted.reduce((a, b) => a + b, 0))}
          </td>
          <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
            {fmtInt(totalOutCalls.reduce((a, b) => a + b, 0))}
          </td>
          <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
            {fmtInt(totalSDCount.reduce((a, b) => a + b, 0))}
          </td>
          <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
            {` ${this.calculateAverage(totalAttempts404)}%`}
          </td>
          <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
            {` ${this.calculateAverage(totalAttempts487)}%`}
          </td>
          <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
            {` ${this.calculateAverage(totalAttempts4xx)}%`}
          </td>
          <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
            {` ${this.calculateAverage(totalAttempts503)}%`}
          </td>
          <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
            {` ${this.calculateAverage(totalAttempts5xx)}%`}
          </td>
          <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
            {` ${this.calculateAverage(totalAttempts6xx)}%`}
          </td>
        </tr>
      );
    }
  }

  onRedirecting(data) {
    console.log("data", data);
    var id = data.carrierID;
    var Name = data.carrier;

    this.setState({ name: Name });
    if (id !== "" && Name !== "") {
      this.props.history.push(`${CARRIER_PER_DAY}/${id}/${Name}`);
    } else {
      Notifications.notify("Id or name not found", "Cannot Redirect", "error");
    }
  }

  handleSort(column) {
    const { sortColumn, sortDirection, data } = this.state;
    let newDirection = "asc";

    if (sortColumn === column) {
      newDirection = sortDirection === "asc" ? "desc" : "asc";
    }

    const sortedData = [...data].sort((a, b) => {
      // Handle "N/A" values and percentage strings
      const aValue =
        a[column] === "N/A" || a[column] === ""
          ? 0
          : typeof a[column] === "string" && a[column].includes("%")
          ? parseFloat(a[column].replace("%", ""))
          : parseFloat(a[column]) || 0;

      const bValue =
        b[column] === "N/A" || b[column] === ""
          ? 0
          : typeof b[column] === "string" && b[column].includes("%")
          ? parseFloat(b[column].replace("%", ""))
          : parseFloat(b[column]) || 0;

      if (newDirection === "asc") {
        return aValue - bValue;
      } else {
        return bValue - aValue;
      }
    });

    this.setState({
      data: sortedData,
      sortColumn: column,
      sortDirection: newDirection,
    });
  }

  getSortIcon(column) {
    const { sortColumn, sortDirection } = this.state;
    if (sortColumn !== column) {
      return (
        <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
          <i
            className="icon-arrow-up8"
            style={{ fontSize: "13px", color: "#ccc" }}
          ></i>
          <i
            className="icon-arrow-down8"
            style={{ fontSize: "13px", color: "#ccc" }}
          ></i>
        </div>
      );
    }
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
        <i
          className="icon-arrow-up8"
          style={{
            fontSize: "13px",
            fontWeight: 900,
            color: sortDirection === "asc" ? "#4caf50" : "#ccc",
          }}
        ></i>
        <i
          className="icon-arrow-down8"
          style={{
            fontSize: "13px",
            fontWeight: 900,
            color: sortDirection === "desc" ? "#4caf50" : "#ccc",
          }}
        ></i>
      </div>
    );
  }

  renderReportTable() {
    const { data, expandedRows, carrierReport, isGettingReport } = this.state;
    console.log(data);
    if (data.length === 0 || data === null) {
      return (
        <div className="ml-3 mt-3">
          <div
            className="dataTables_info"
            id="DataTables_Table_0_info"
            role="status"
            aria-live="polite"
          >
            Showing 0 of 0 entries
          </div>
          <div
            className="dataTables_paginate paging_simple_numbers"
            id="DataTables_Table_0_paginate"
          ></div>
        </div>
      );
    } else {
      return data.map((stats, idx) => {
        const isExpanded = expandedRows[idx];
        return (
          <>
            <tr key={idx} className="left_align">
              <td className="table-data">
                <i
                  className={`icon-plus3 ml-2 ${
                    isExpanded ? "icon-minus3" : ""
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => this.toggleRow(idx)}
                ></i>
              </td>
              <td
                className="table-data"
                onClick={this.onRedirecting.bind(this, stats)}
              >
                <Link>{stats.carrier}</Link>
              </td>
              <td className="table-data" style={{textAlign:'right'}}>{fmtDollar4(stats.revenue)}</td>
              <td className="table-data" style={{textAlign:'right'}}> {fmtDollar4(stats.cost)}</td>
              <td className="table-data" style={{textAlign:'right'}}>{fmtDollar4(stats.profit)}</td>
              <td className="table-data" style={{textAlign:'right'}}>{fmtMins(stats.minutes)}</td>
              <td className="table-data" style={{textAlign:'right'}}> {stats.ACD}</td>
              <td className="table-data" style={{textAlign:'right'}}> {stats.SDP}</td>
              <td className="table-data" style={{textAlign:'right'}}>{stats.ASR}</td>
              <td className="table-data" style={{textAlign:'right'}}>{fmtInt(stats.completed)}</td>
              <td className="table-data" style={{textAlign:'right'}}>{fmtInt(stats.outCalls)}</td>
              <td className="table-data" style={{textAlign:'right'}}>{fmtInt(stats.sdCount)}</td>
              <td className="table-data" style={{textAlign:'right'}}>{stats.attempts_404 !== undefined && stats.attempts_404 !== "N/A" && !isNaN(stats.attempts_404) ? `${stats.attempts_404}%` : (stats.attempts_404 || "N/A")}</td>
              <td className="table-data" style={{textAlign:'right'}}>{stats.attempts_487 !== undefined && stats.attempts_487 !== "N/A" && !isNaN(stats.attempts_487) ? `${stats.attempts_487}%` : (stats.attempts_487 || "N/A")}</td>
              <td className="table-data" style={{textAlign:'right'}}>{stats.attempts_4xx !== undefined && stats.attempts_4xx !== "N/A" && !isNaN(stats.attempts_4xx) ? `${stats.attempts_4xx}%` : (stats.attempts_4xx || "N/A")}</td>
              <td className="table-data" style={{textAlign:'right'}}>{stats.attempts_503 !== undefined && stats.attempts_503 !== "N/A" && !isNaN(stats.attempts_503) ? `${stats.attempts_503}%` : (stats.attempts_503 || "N/A")}</td>
              <td className="table-data" style={{textAlign:'right'}}>{stats.attempts_5xx !== undefined && stats.attempts_5xx !== "N/A" && !isNaN(stats.attempts_5xx) ? `${stats.attempts_5xx}%` : (stats.attempts_5xx || "N/A")}</td>
              <td className="table-data" style={{textAlign:'right'}}>{stats.attempts_6xx !== undefined && stats.attempts_6xx !== "N/A" && !isNaN(stats.attempts_6xx) ? `${stats.attempts_6xx}%` : (stats.attempts_6xx || "N/A")}</td>
            </tr>
            {isExpanded && (
              <>
                {isGettingReport ? (
                  <tr>
                    <td colSpan="20" className="text-center">
                      <CustomLoader />
                    </td>
                  </tr>
                ) : (
                  <>
                    {carrierReport.length === 0 || carrierReport === null ? (
                      <tr>
                        <td
                          className="text-center"
                          style={{ backgroundColor: "#ffffff" }}
                          colSpan="20"
                        >
                          No data available
                        </td>
                      </tr>
                    ) : (
                      carrierReport.map((rowData, index) => (
                        <tr key={index} className="left_align">
                          <td className="table-data">{""}</td>
                          <td className="table-data">
                            {rowData.accountName || "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            {rowData.revenue != null && rowData.revenue !== "N/A" ? fmtDollar4(rowData.revenue) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            {rowData.cost != null && rowData.cost !== "N/A" ? fmtDollar4(rowData.cost) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            {rowData.profit != null && rowData.profit !== "N/A" ? fmtDollar4(rowData.profit) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            {rowData.minutes != null && rowData.minutes !== "N/A" ? fmtMins(rowData.minutes) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>{rowData.ACD !== undefined && rowData.ACD !== "N/A" && !isNaN(rowData.ACD) ? `${rowData.ACD}%` : (rowData.ACD || "N/A")}</td>
                          <td className="table-data" style={{textAlign:'right'}}>{rowData.SDP !== undefined && rowData.SDP !== "N/A" && !isNaN(rowData.SDP) ? `${rowData.SDP}%` : (rowData.SDP || "N/A")}</td>
                          <td className="table-data" style={{textAlign:'right'}}>{rowData.ASR !== undefined && rowData.ASR !== "N/A" && !isNaN(rowData.ASR) ? `${rowData.ASR}%` : (rowData.ASR || "N/A")}</td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            {rowData.completed != null && rowData.completed !== "N/A" ? fmtInt(rowData.completed) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            {rowData.outCalls != null && rowData.outCalls !== "N/A" ? fmtInt(rowData.outCalls) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>{rowData.sdCount != null && rowData.sdCount !== "N/A" ? fmtInt(rowData.sdCount) : "N/A"}</td>
                          <td className="table-data" style={{textAlign:'right'}}>{rowData.attempts_404 !== undefined && rowData.attempts_404 !== "N/A" && !isNaN(rowData.attempts_404) ? `${rowData.attempts_404}%` : (rowData.attempts_404 || "N/A")}</td>
                          <td className="table-data" style={{textAlign:'right'}}>{rowData.attempts_487 !== undefined && rowData.attempts_487 !== "N/A" && !isNaN(rowData.attempts_487) ? `${rowData.attempts_487}%` : (rowData.attempts_487 || "N/A")}</td>
                          <td className="table-data" style={{textAlign:'right'}}>{rowData.attempts_4xx !== undefined && rowData.attempts_4xx !== "N/A" && !isNaN(rowData.attempts_4xx) ? `${rowData.attempts_4xx}%` : (rowData.attempts_4xx || "N/A")}</td>
                          <td className="table-data" style={{textAlign:'right'}}>{rowData.attempts_503 !== undefined && rowData.attempts_503 !== "N/A" && !isNaN(rowData.attempts_503) ? `${rowData.attempts_503}%` : (rowData.attempts_503 || "N/A")}</td>
                          <td className="table-data" style={{textAlign:'right'}}>{rowData.attempts_5xx !== undefined && rowData.attempts_5xx !== "N/A" && !isNaN(rowData.attempts_5xx) ? `${rowData.attempts_5xx}%` : (rowData.attempts_5xx || "N/A")}</td>
                          <td className="table-data" style={{textAlign:'right'}}>{rowData.attempts_6xx !== undefined && rowData.attempts_6xx !== "N/A" && !isNaN(rowData.attempts_6xx) ? `${rowData.attempts_6xx}%` : (rowData.attempts_6xx || "N/A")}</td>
                        </tr>
                      ))
                    )}
                  </>
                )}
              </>
            )}
          </>
        );
      });
    }
  }

  // Helper function to calculate average for a column
  calculateAverage(arr) {
    if (!arr.length) return 0;
    // Filter out non-numeric and N/A values
    const filtered = arr.map(v => (v === "N/A" ? 0 : parseFloat(v) || 0));
    const sum = filtered.reduce((a, b) => a + b, 0);
    return (sum / arr.length).toFixed(2);
  }

  render() {
    const {
      startDate,
      endDate,
      isGetting,
      selectedCarrier,
      carrierList,
      data,
      isBtnSpin,
      isDownLoadSpin,
      excludeNoActivity,
    } = this.state;
    if (this.state.isLoginURL === true) {
      return <Redirect to={LOGIN_URL}></Redirect>;
    }
    return (
      <div>
        <div className="">
          <div className="card-header header-elements-inline p-0 py-1 mb-1">
            <h5
              style={{ fontWeight: "700", fontSize: "24px" }}
              className="card-title"
            ></h5>
            <div className="header-elements"></div>
          </div>
          <div class="bg-light rounded border p-0 mb-2">
            <div style={{display:'flex',flexWrap:'wrap',gap:'6px',padding:'12px 16px 0 16px'}}>
              {[
                { key: "today", label: "Today" },
                { key: "yesterday", label: "Yesterday" },
                { key: "thisWeek", label: "This Week" },
                { key: "thisMonth", label: "This Month" },
              ].map((item) => (
                <button
                  key={item.key}
                  type="button"
                  onClick={() => this.handleQuickDateSelect(item.key)}
                  style={{
                    background: this.state.quickDatePreset === item.key ? "#4caf50" : "#fff",
                    color: this.state.quickDatePreset === item.key ? "#fff" : "#475569",
                    border: this.state.quickDatePreset === item.key ? "1px solid #4caf50" : "1px solid #dee2e6",
                    borderRadius: "6px",
                    padding: "4px 14px",
                    fontSize: "12px",
                    fontWeight: "500",
                    cursor: "pointer",
                  }}
                >
                  {item.label}
                </button>
              ))}
            </div>
            <div class="d-flex justify-content-between flex-wrap p-0">
            <div class=" py-2 px-3 mb-1">
              <div class="">
                <label className="fs-14">
                  Start Date
                  <span className="text-muted "> UTC Time-zone</span>{" "}
                </label>
                <div class="input-group">
                  <DateRangePicker
                    key={"start-" + moment(startDate).valueOf()}
                    showWeekNumbers
                    onCallback={(date) => this.handleDate(date, "start")}
                    initialSettings={{
                      singleDatePicker: true,
                      showDropdowns: true,
                      startDate: moment(startDate),
                      locale: {
                        format: "MMMM/DD/YYYY",
                      },
                    }}
                  >
                    <input
                      type="text"
                      className="form-control"
                      style={{ minWidth: "300px" }}
                    />
                  </DateRangePicker>
                </div>
              </div>
            </div>
            <div class=" py-2 px-3 mb-1">
              <div class="">
                <label className="fs-14">
                  End Date <span className="text-muted "> UTC Time-zone</span>{" "}
                </label>
                <div class="input-group">
                  <DateRangePicker
                    key={"end-" + moment(endDate).valueOf()}
                    onCallback={(date) => this.handleDate(date, "end")}
                    initialSettings={{
                      singleDatePicker: true,
                      showDropdowns: true,
                      startDate: moment(endDate),
                      locale: {
                        format: "MMMM/DD/YYYY",
                      },
                    }}
                  >
                    <input
                      type="text"
                      className="form-control"
                      style={{ minWidth: "300px" }}
                    />
                  </DateRangePicker>
                </div>
              </div>
            </div>
            <div class=" py-1 px-3 mb-1">
              <label
                style={{ fontWeight: "400", fontSize: "16px" }}
                className=""
              >
                Filter Carrier
              </label>
              <div class=" w-20em ">
                <MultiSelect
                  options={carrierList}
                  selected={selectedCarrier}
                  onSelectedChanged={(selectedCarrier) =>
                    this.setState({ selectedCarrier })
                  }
                  overrideStrings={{
                    selectSomeItems: "Filter Carrier",
                    allItemsAreSelected: "All Carrier are Selected",
                    selectAll: "Select All Carrier",
                    search: "Search Carrier",
                  }}
                />
              </div>
              <div
                className="custom-control custom-checkbox"
                style={{ marginLeft: 300, marginTop: -30 }}
              >
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="excludeNoActivity"
                  checked={excludeNoActivity}
                  onChange={this.handleExcludeNoActivity}
                />
                <label
                  className="custom-control-label"
                  htmlFor="excludeNoActivity"
                  style={{ fontSize: "14px" }}
                >
                  Exclude ones with no activity
                </label>
              </div>
            </div>

            <div class="py-2 px-3 mb-1">
              <div className="" style={{ marginLeft: "", marginTop: "2.2em" }}>
                <button
                  type="submit"
                  className="btn btn-primary main-button btn-sm "
                  onClick={this.getReportOnSelectDate}
                >
                  Search{" "}
                  <i
                    class={`${
                      isBtnSpin ? "icon-spinner4 spinner" : "icon-arrow-right8"
                    } ml-2`}
                  ></i>
                </button>
              </div>
            </div>
            </div>
          </div>
          {/* row */}
          <div className="card-header header-elements-inline p-0 py-1 mb-2">
            <h5
              style={{ fontWeight: "700", fontSize: "24px" }}
              className="card-title"
            ></h5>
            <div className="header-elements">
              <button
                type="submit"
                className="btn btn-success main-button "
                onClick={this.getReportOnSelectDate.bind(this, "download")}
              >
                Download CSV{" "}
                <i
                  class={`${
                    isDownLoadSpin ? "icon-spinner4 spinner" : "icon-download7"
                  } ml-2`}
                ></i>
              </button>
            </div>
          </div>
          <div className="">
            <div
              className="table-responsive "
              style={{
                overflowX: "auto",
                overflowY: "auto",
                maxHeight: "56em",
              }}
            >
              <table className="table-style table table-striped dataTable no-footer">
                <thead>
                  <tr className="stickeyHeader table-heading-style">
                    <th></th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => this.handleSort("carrier")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <span>Carrier</span>
                        {this.getSortIcon("carrier")}
                      </div>
                    </th>
                    <th
                      style={{ cursor: "pointer", textAlign: "right" }}
                      onClick={() => this.handleSort("revenue")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span>Revenue</span>
                        {this.getSortIcon("revenue")}
                      </div>
                    </th>
                    <th
                      style={{ cursor: "pointer", textAlign: "right" }}
                      onClick={() => this.handleSort("cost")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span>Cost</span>
                        {this.getSortIcon("cost")}
                      </div>
                    </th>
                    <th
                      style={{ cursor: "pointer", textAlign: "right" }}
                      onClick={() => this.handleSort("profit")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span>Profit</span>
                        {this.getSortIcon("profit")}
                      </div>
                    </th>
                    <th
                      style={{ cursor: "pointer", textAlign: "right" }}
                      onClick={() => this.handleSort("minutes")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span>Minutes</span>
                        {this.getSortIcon("minutes")}
                      </div>
                    </th>
                    <th
                      style={{ cursor: "pointer", textAlign: "right" }}
                      onClick={() => this.handleSort("ACD")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span>ACD</span>
                        {this.getSortIcon("ACD")}
                      </div>
                    </th>
                    <th
                      style={{ cursor: "pointer", textAlign: "right" }}
                      onClick={() => this.handleSort("SDP")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span>SDP</span>
                        {this.getSortIcon("SDP")}
                      </div>
                    </th>
                    <th
                      style={{ cursor: "pointer", textAlign: "right" }}
                      onClick={() => this.handleSort("ASR")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span>ASR</span>
                        {this.getSortIcon("ASR")}
                      </div>
                    </th>
                    <th
                      style={{ cursor: "pointer", textAlign: "right" }}
                      onClick={() => this.handleSort("completed")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span>Completed</span>
                        {this.getSortIcon("completed")}
                      </div>
                    </th>
                    <th
                      style={{ cursor: "pointer", textAlign: "right" }}
                      onClick={() => this.handleSort("outCalls")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span>Out Calls</span>
                        {this.getSortIcon("outCalls")}
                      </div>
                    </th>
                    <th
                      style={{ cursor: "pointer", textAlign: "right" }}
                      onClick={() => this.handleSort("sdCount")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span>SD Count</span>
                        {this.getSortIcon("sdCount")}
                      </div>
                    </th>
                    <th
                      style={{ cursor: "pointer", textAlign: "right" }}
                      onClick={() => this.handleSort("attempts_404")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span>404</span>
                        {this.getSortIcon("attempts_404")}
                      </div>
                    </th>
                    <th
                      style={{ cursor: "pointer", textAlign: "right" }}
                      onClick={() => this.handleSort("attempts_487")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span>487</span>
                        {this.getSortIcon("attempts_487")}
                      </div>
                    </th>
                    <th
                      style={{ cursor: "pointer", textAlign: "right" }}
                      onClick={() => this.handleSort("attempts_4xx")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span>4XX</span>
                        {this.getSortIcon("attempts_4xx")}
                      </div>
                    </th>
                    <th
                      style={{ cursor: "pointer", textAlign: "right" }}
                      onClick={() => this.handleSort("attempts_503")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span>503</span>
                        {this.getSortIcon("attempts_503")}
                      </div>
                    </th>
                    <th
                      style={{ cursor: "pointer", textAlign: "right" }}
                      onClick={() => this.handleSort("attempts_5xx")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span>5XX</span>
                        {this.getSortIcon("attempts_5xx")}
                      </div>
                    </th>
                    <th
                      style={{ cursor: "pointer", textAlign: "right" }}
                      onClick={() => this.handleSort("attempts_6xx")}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span>6XX</span>
                        {this.getSortIcon("attempts_6xx")}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {isGetting ? <CustomLoader /> : this.renderReportTable()}
                  {data.length > 0 ? this.returnTotal() : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <ReactTooltip
          type="info"
          backgroundColor="#4caf50"
          place="top"
          effect="solid"
        />
      </div>
    );
  }
}
export default withRouter(ChangeCarrierStats);
